import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CqExtraParamsDestination } from 'src/app/beans/components/cq-extra-params/cq-extra-params-destination.bean';
import { Device } from 'src/app/beans/device/device.bean';
import { Licence } from 'src/app/beans/licence/licence.bean';
import { User } from 'src/app/beans/login/user/user.bean';
import { Site } from 'src/app/beans/site/site.bean';
import { CustomButton, CustomColumn, CustomTableComponent, HeaderButton } from 'src/app/components/table/custom-table/custom-table.component';
import { ClipboardDialog } from 'src/app/dialogs/clipboard/clipboard.dialog';
import { GenericDialog } from 'src/app/dialogs/generic/generic.dialog';
import { HandlerManager } from 'src/app/managers/handler/handler.manager';
import { LoadingManager } from 'src/app/managers/loading/loading.manager';
import { PipeManager } from 'src/app/managers/pipe/pipe.manager';
import { SessionManager } from 'src/app/managers/session/session.manager';

var FileSaver = require('file-saver');

@Component({
  selector: 'licence',
  templateUrl: './licence.page.html',
  styleUrls: ['./licence.page.scss']
})
export class LicencePage implements OnInit {

  @ViewChild('licenceTable') licenceTable: CustomTableComponent;

  _site: Site = null

  licenceColumns: CustomColumn []= [
    {
      isId    : true,
      label   : "id",
      name    : "id",
      display : ( val : any ) => false ,
    },
    {
      isId    : false,
      label   : "type",
      name    : "type",
      display : ( val : any ) => false ,
    },
    {
      label : "deviceName",
      name  : "tables.licences.labels.deviceName",
    },
    {
      pipe  : (value: any) => this._pipe.tables().is_not_null(value, "-"),
      label   : "activation",
      name    : "tables.licences.labels.activation",
    },
    /*
    {
      pipe  : (value: any) => this._pipe.tables().is_not_null(value, "-"),
      label   : "androidId",
      name    : "tables.licences.labels.android",
    },
    */
    {
      pipe  : (value: any) => this._pipe.tables().is_not_null(value, "-"),
      label   : "uniqueId",
      name    : "tables.licences.labels.unique",
    },
    /*
    {
      style_filter: () =>  "{'text-left': true }" ,
      pipe    : (_: any, r_idx: number ) =>  this.getCodes(r_idx) ,
      label   : "activation",
      name    : "tables.licences.labels.codes",
    },
    */
    {
      pipe  : (value: any) => this._pipe.tables().is_not_null(value, "-"),
      label   : "appVersion",
      name    : "tables.licences.labels.appVersion",
    },
    {
      pipe  : (value: any) => this._pipe.tables().is_not_null(value, "-"),
      label   : "apiVersion",
      name    : "tables.licences.labels.apiVersion",
    },
    {
      pipe : (active: any) => this._pipe.tables().is_assigned(active),
      label   : "registered",
      name    : "tables.licences.labels.registered",
    }
  ]

  licences: Licence[] = []

  buttons: CustomButton[] = [
    {
      display: (el: any) => this.displayActivation(el),
      label : "change_status",
      column: "",
      name  : (row: any ) => {
        if( !row ) return
        return row?.registered == 0 ? "tables.licences.labels.activate" : "tables.licences.labels.deactivate"
      },
      action: async (item: any) => this.manageActivation(item)
    },
    {
      display: (el: any) => this.displayToken(el),
      label : "display_token",
      column: "",
      name  : (row: any ) => "tables.licences.labels.get_token",
      action: async (item: any) => this.showToken(item)
    },
  ]

  header_buttons: HeaderButton[] = [
    {
      label    : "download_excel",
      name     : "Scarica Configurazione",
      action   : async () => {
        this.extractExcel()
      } ,
      display  : () => this.canGetExcel()
    },
    {
      label    : "activate_all",
      name     : "Attiva tutti",
      action   : async () => {
        this.activateAll()
      } ,
      display  : () => this.canActivateAll()
    }
  ]
  constructor(
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
    private _pipe   : PipeManager   ,
    private _dialog : MatDialog     ,
  ) { }

  auth: Map<string, any> = new Map ([
    ["LICENCE_ACTIVATE"       , 0   ],
    ["LICENCE_READ_TOKEN"     , 0   ],
    ["LICENCE_DEACTIVATE"     , 0   ],
    ["LICENCE_EXCEL"          , 0   ],
    ["LICENCE_ACTIVATE_ALL"   , 0   ],
    ["WEB_JNEXT_URL"          , null],
  ])

  ngOnInit(): void {}

  async retrieveConfParams( site: Site){
    let user = this._session.user().get()
    if (!User.isKind( user ))
      return
    user = user as User

    const keys = Array.from( this.auth.keys() )

    const dest = {
      level       : "SI",
      levelid     : site.id,
      type        : "WAPP",
      codes       : keys
    }


    const resp = await this._handler.extraParams().getParamsByCodes( user.token, dest  )
    console.log(resp);

    if(!resp) return

    for ( const param of resp ) {
      if(param.value1)
        this.auth.set(param.code, param.value1)
      else if (param.text1)
        this.auth.set(param.code, param.text1)
    }

    console.log( this.auth );

  }

  async siteChange( site: Site ){
    if( !this._site )
      await this.retrieveConfParams( site )
    this._site = site
    this.retrieveLicences()
  }

  async retrieveLicences( dialogData ?: any){

    let user = this._session.user().get()
    if (!User.isKind( user ))
      return
    user = user as User

    this.licenceTable.reloadData()

    this._loader.start()
    const resp = await this._handler.licence().list( user.token, this._site.id )
    this._loader.stop()

    this.licenceTable.dataLoaded()

    this.licences = resp

    this.licences.sort( (a,b) => this._pipe.sorting().sort( a.deviceName.toLowerCase(), b.deviceName.toLowerCase()) )
    this.licences.sort( (a,b) => this._pipe.sorting().sort( a.deviceName.length, b.deviceName.length ) )
    this.licences.sort( (a,b) => this._pipe.sorting().sort( a.type, b.type ) )

    if( dialogData ) {
      let item = this.licences.filter( licence => licence.id == dialogData.item.id )
      if(item && item[0])
        this.showDialog( item[0], dialogData.token )
    }

  }

  async manageActivation(item: any){
    if( !item ) return
    let user = this._session.user().get()
    if( !User.isKind( user ))
      return

    user = user as User

    this._loader.start()

    let resp = null
    let dialogData = null
    if(item?.registered == 0){
      resp = await this._handler.licence().activate( user.token, item.id )
      if(item && item.type != 20)
        dialogData = { item , token: resp.response}
    }
    else
      resp = await this._handler.licence().deactivate( user.token, item.id )

    if( resp?.result == 1)
      await this.retrieveLicences( dialogData )
    else
      this._loader.stop()

  }

  async showToken(item: any){
    if( !item ) return

    let user = this._session.user().get()
    if( !User.isKind( user ))
      return

    user = user as User

    let resp = null
    if( this.auth.get("LICENCE_READ_TOKEN") == 1  ){
      this._loader.start()

      resp = await this._handler.licence().getToken( user.token, item.id )

      this._loader.stop()
    }




    this.showDialog( item, resp )

  }

  showDialog( l: Licence, token: string ){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus    = false;

    let values = []

    console.log(l);

    let tokenObj = {
      clipboard_label : "Token",
      clipboard_text  : token
    }

    let jNextObj = {
      clipboard_label : "Jnext Url",
      clipboard_text  : this.formatJnextUrl(l)
    }

    if( token && l?.type != 20)
      values.push(tokenObj)

    if( this.canGetJNextUrl() && l?.type == 20 )
      values.push(jNextObj)

      console.log(values );

    dialogConfig.data = {
      title           : "API",
      values: values
    }
    this._dialog.open(ClipboardDialog, dialogConfig);
  }

  formatJnextUrl(l: Licence){
    const base: string= this.auth.get("WEB_JNEXT_URL")
    if( !base ) return null

    try{
      return base.replace( /{ANDROID}/gi, l.androidId ).replace( /{ACTIVATION}/gi, l.activation )
    }catch(e){
      console.log(e);
      return null
    }
  }

  displayActivation( el: any ){
    if(!el)
      return true

    if( el?.registered == 0 )
      return this.auth.get("LICENCE_ACTIVATE") == 1
    else
      return this.auth.get("LICENCE_DEACTIVATE") == 1
  }

  displayToken( el: any ){
    return el?.registered == 1 && ( ( el?.type != 20 && this.auth.get("LICENCE_READ_TOKEN") == 1 ) || ( el?.type == 20 && this.canGetJNextUrl() ) )
  }

  canActivateAll( ){
    return this.auth.get("LICENCE_ACTIVATE_ALL") == 1 && this.licences?.length > 0 && !this.isAllActive()
  }

  canGetExcel(){
    return this.auth.get("LICENCE_EXCEL") == 1
  }

  canGetJNextUrl(){
    return this.auth.get("WEB_JNEXT_URL") !== null
  }

  countActive(){
    if (!this.licences || this.licences?.length == 0 )
      return  0

    let count = 0
    for ( let licence of this.licences){
      if ( licence.registered == 1)
        count++
    }
    return count
  }

  isAllActive(){
    return this.countActive() === this.licences?.length
  }

  async activateAll(){
    let user = this._session.user().get()
    if( !User.isKind( user ))
      return

    user = user as User

    this._loader.start()

    let resp = null

    resp = await this._handler.licence().activateAll( user.token, this._site.id )
    console.log(resp);

    if( resp?.result == 1)
      await this.retrieveLicences()
    else
      this._loader.stop()
  }

  async extractExcel(){
    let user = this._session.user().get()
    if( !User.isKind( user ))
      return

    user = user as User

    this._loader.start()
    const resp = await this._handler.licence().extractExcel( user.token, this._site.id )
    this._loader.stop()

    if ( !resp ) return
    try {
      var blob = new Blob( [resp], { type: "application/vnd.ms-excel" } );
      FileSaver.saveAs( blob, `${this.generateFileName()}.xls` );
    }catch (error){
      console.log(error);
    }

  }

  generateFileName(){
    return `conf_${this.formatName(this._site.name)}`
  }

  formatName( name: string)
  {
    name = name .split('.').join('_')
                .split('-').join(' ')
                .split(' ').join('_')
    name = name.replace(/ +/g, ' ')
    return name.replace(/_+/g,'_')
  }

  getCodes( r_idx: number ){
    const licence = this.licences[r_idx]

    const codes =
    `
    <div class='codes-grid'>
      <span class='text-left'>  activation  </span>
      <span class='text-center'> ${licence.activation  ? licence.activation  : "-"} </span>
      <span class='text-left'>  android     </span>
      <span class='text-center'> ${licence.androidId   ? licence.androidId   : "-"} </span>
      <span class='text-left'>  unique      </span>
      <span class='text-center'> ${licence.uniqueId    ? licence.uniqueId    : "-"} </span>
    </div>
    `;

    return  codes
  }
}
